import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface SubScribeInfo {
  hasPay: boolean ;
}

const subScribeInfo: StateCreator< SubScribeInfo, [
  ['zustand/immer', never],
]> = () => ({
  hasPay: false,
});
const useSubScribeStore: UseBoundStore<StoreApi<SubScribeInfo>> = create<SubScribeInfo>()(immer(subScribeInfo));
export default useSubScribeStore;

/**
 * 更新用户最新是否支付
 * @param index
 */
export const setHasPay = (val: boolean) => {
  useSubScribeStore.setState(() => {
    return {
      hasPay: val,
    };
  });
};
